module.exports = __webpack_public_path__ + "img/linha-trilha-dashboard.1d0d88d8.svg";